
export default {
  name: 'FilterTag',
  props: {
    tag: {
      type: Object,
      default() {
        return {}
      },
      required: true,
    },
  },
  methods: {
    clickHandler() {
      this.$emit('on-delete-tag', { tag: this.tag })
    },
  },
}
